<mat-toolbar class="topbar topbar--with-search gap-10">
  <div class="topbar__start">
    <!-- --------------------------------------------------------------- -->
    <!-- Desktop Menu -->
    @if(showToggle && sidenavCollapsedState) {
    <button
      mat-icon-button
      type="button"
      class="d-flex justify-content-center"
      [attr.aria-expanded]="false"
      (click)="toggleCollapsed.emit()">
      <i-tabler name="layout-sidebar-left-expand" class="icon-20 d-flex"></i-tabler>
    </button>
    }

    <!-- Mobile Menu -->
    @if(!showToggle) {
    <button mat-icon-button (click)="toggleMobileNav.emit()" class="d-flex justify-content-center">
      <i-tabler name="menu-2" class="icon-20 d-flex"></i-tabler>
    </button>
    <button
      mat-icon-button
      type="button"
      class="d-flex justify-content-center topbar__mobile-search-btn"
      [attr.aria-label]="'header.search_placeholder' | translate"
      [matTooltip]="'header.search_placeholder' | translate"
      (click)="openMobileSearch()">
      <i-tabler name="search" class="icon-20 d-flex"></i-tabler>
    </button>
    }
    <!-- --------------------------------------------------------------- -->
  </div>

  @if (showToggle) {
  <div class="topbar__center">
    <app-header-search></app-header-search>
  </div>
  }

  <div class="topbar__end">
  @if (showOpsConsoleEntry()) {
  <a
    mat-icon-button
    routerLink="/ops"
    class="topbar__ops-console-btn d-flex justify-content-center"
    [matTooltip]="'header.ops_console' | translate">
    <i-tabler name="tool" class="icon-20 d-flex"></i-tabler>
  </a>
  }
  <button mat-icon-button (click)="onSupport()" class="d-flex justify-content-center"
    [matTooltip]="'header.contact_support' | translate">
    <i-tabler name="mail" class="icon-20 d-flex"></i-tabler>
  </button>

  <!-- --------------------------------------------------------------- -->
  <!-- WebSocket Notifications -->
  <!-- --------------------------------------------------------------- -->
  <app-notifications></app-notifications>

  <!-- --------------------------------------------------------------- -->
  <!-- langugage Dropdown -->
  <!-- --------------------------------------------------------------- -->
  <button [matMenuTriggerFor]="flags" mat-icon-button class="topbar__language-btn d-flex justify-content-center">
    <img
      [src]="selectedLanguage.icon"
      class="topbar__language-flag"
      [alt]="selectedLanguage.language" />
  </button>
  <mat-menu #flags="matMenu" class="cardWithShadow">
    @for(lang of languages; track lang.icon) {
    <button mat-menu-item (click)="changeLanguage(lang)">
      <div class="d-flex align-items-center">
        <img [src]="lang.icon" class="topbar__language-flag m-r-8" [alt]="lang.language" />
        <span class=" f-s-14">{{ lang.language }}</span>
      </div>
    </button>
    }
  </mat-menu>
  @if(options.theme=='light'){
  <button mat-icon-button aria-label="lightdark" class="d-flex justify-content-center" (click)="setlightDark('dark')">
    <i-tabler class="d-flex icon-22" [name]="'moon'"></i-tabler>
  </button>
  }@else{
  <button mat-icon-button aria-label="lightdark" class="d-flex justify-content-center" (click)="setlightDark('light')">
    <i-tabler class="d-flex icon-22" [name]="'sun'"></i-tabler>
  </button>
  }

  <!-- --------------------------------------------------------------- -->
  <!-- Notification Dropdown -->
  <!-- --------------------------------------------------------------- -->
  <!-- <button
    mat-icon-button
    [matMenuTriggerFor]="notificationmenu"
    aria-label="Notifications"
  >
    <i-tabler
      class="d-flex"
      name="bell"
      matBadge="1"
      matBadgeColor="primary"
    ></i-tabler>
  </button>
  <mat-menu #notificationmenu="matMenu" class="topbar-dd cardWithShadow">
    <div class="d-flex align-items-center p-x-32 p-y-16">
      <h6 class="f-s-16 f-w-600 m-0 ">Notifications</h6>
      <span class="m-l-auto">
        <span class="bg-primary text-white p-x-8 p-y-4 f-w-500 rounded f-s-12"
          >5 new</span
        >
      </span>
    </div>

    @for(notification of notifications; track notification.title) {
    <button mat-menu-item class="p-x-32 p-y-16">
      <div class="d-flex align-items-center">
        <img [src]="notification.img" class="rounded-circle" width="48" />
        <div class="m-l-16">
          <h5 class="f-s-14 f-w-600 m-0 ">
            {{ notification.title }}
          </h5>
          <span>{{ notification.subtitle }}</span>
        </div>
      </div>
    </button>
    }

    <div class="p-y-12 p-x-32">
      <button mat-stroked-button color="primary" class="w-100">
        See all notifications
      </button>
    </div>
  </mat-menu> -->



  <!-- --------------------------------------------------------------- -->
  <!-- profile Dropdown -->
  <!-- --------------------------------------------------------------- -->
  <button mat-icon-button [matMenuTriggerFor]="profilemenu" aria-label="Profile">
    <span
      class="rounded-circle bg-primary text-white d-flex align-items-center justify-content-center header-profile-avatar profile-dd">
      {{ user.initials }}
    </span>
  </button>
  <mat-menu #profilemenu="matMenu" xPosition="before" class="topbar-dd profile-menu cardWithShadow">
    <div class="position-relative profile-menu__content">
      <div class="profile-menu__header p-x-32 p-y-16">
        <h6 class="f-s-16 f-w-600 m-0 profile-menu__title">{{ 'header.User Profile' | translate }}</h6>
        <div class="d-flex align-items-center p-b-24 b-b-1 m-t-16 profile-menu__user">
          <span
            class="profile-menu__avatar rounded-circle bg-primary text-white d-flex align-items-center justify-content-center">
            {{ user.initials }}
          </span>
          <div class="m-l-16 profile-menu__details">
            <h6 class="f-s-14 f-w-600 m-0 profile-menu__name">{{ user.name }}</h6>
            <span class="d-flex align-items-center profile-menu__email">
              <i-tabler name="mail" class="icon-15 m-r-4 profile-menu__email-icon"></i-tabler>
              <span class="profile-menu__email-text">{{ user.email }}</span>
            </span>
          </div>
        </div>
      </div>

      <div class="profile-menu__actions p-y-12 p-x-32">
        <a routerLink="/profile" mat-stroked-button color="primary" class="w-100 m-b-8">{{ 'header.Profile' | translate }}</a>
        <a (click)="logOut()" mat-stroked-button color="primary" class="w-100">{{ 'header.Logout' | translate }}</a>
      </div>
    </div>
  </mat-menu>
  </div>
</mat-toolbar>
<app-breadcrumb [translateKey]="'breadcrumb.titles'"></app-breadcrumb>